import React, { useState } from 'react';
import '../styles/FeedbackNotice.css';

const FeedbackNotice = () => {
  const [dismissed, setDismissed] = useState(false);

  // Don't show if user dismissed the notice (stored in localStorage) and it hasn't expired
  const dismissedKey = 'feedback-notice-dismissed';
  const storedExpiry = localStorage.getItem(dismissedKey);
  const isDismissedAndNotExpired = storedExpiry && new Date().getTime() < parseInt(storedExpiry);
  if (dismissed || isDismissedAndNotExpired) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
    // Remember dismissal for 24 hours
    const expiryTime = new Date().getTime() + (24 * 60 * 60 * 1000);
    localStorage.setItem(dismissedKey, expiryTime.toString());
  };

  return (
    <div className="feedback-notice">
      <div className="feedback-notice-container">
        <div className="feedback-notice-icon">
          🎮
        </div>
        <div className="feedback-notice-content">
          <h3 className="feedback-notice-title">Help Shape the Future of GamersUnion 🎮</h3>
          <p className="feedback-notice-message">
            GamersUnion has grown thanks to its community, and I'd love to hear your thoughts.
            Whether you've used our giveaways, game recommender, chats, or creator tools, your
            feedback helps me understand what's working and what needs improvement.
            Please take a minute to fill out this short review form. Every response is read
            and helps guide future updates and features.
          </p>
          <ul className="feedback-notice-perks">
            <li>✅ Takes less than 5 minutes</li>
            <li>✅ Honest feedback is appreciated</li>
            <li>✅ Feature suggestions are welcome</li>
          </ul>
          <div className="feedback-notice-actions">
            <a
              href="https://forms.gle/4REdS9hyGNMTBo1o9"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-feedback"
            >
              Fill Out Feedback Form
            </a>
            <button className="btn-dismiss-feedback" onClick={handleDismiss}>
              Remind Me Later
            </button>
          </div>
        </div>
        <button className="feedback-notice-close" onClick={handleDismiss} aria-label="Close notice">
          ×
        </button>
      </div>
    </div>
  );
};

export default FeedbackNotice;
